import React from 'react'

import { Provider } from 'react-redux'
import store, { persistor } from '../../../js/lib/redux/store'
import { PersistGate } from 'redux-persist/integration/react'
import BookingRouter from '../../router/BookingRouter'

const Booking = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BookingRouter />
      </PersistGate>
    </Provider>
  )
}

export default Booking
